import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["statusSelect", "reasonContainer", "reasonInput"]

  connect() {
    // Initialize visibility without submitting
    this.updateVisibility()
  }

  toggleReason() {
    // Check if statusSelect is a checkbox or select
    const isCheckbox = this.statusSelectTarget.type === "checkbox"
    const isRanked = isCheckbox ? this.statusSelectTarget.checked : this.statusSelectTarget.value === "true"

    // Update visibility
    this.updateVisibility()

    // Submit the form when status changes
    this.element.requestSubmit()
  }

  updateVisibility() {
    // Check if statusSelect is a checkbox or select
    const isCheckbox = this.statusSelectTarget.type === "checkbox"
    const isRanked = isCheckbox ? this.statusSelectTarget.checked : this.statusSelectTarget.value === "true"

    if (isRanked) {
      this.reasonContainerTarget.classList.add("hidden")
      this.reasonInputTarget.value = ""
    } else {
      this.reasonContainerTarget.classList.remove("hidden")
    }
  }

  submitForm() {
    // Submit form only when user leaves the reason field (onblur)
    this.element.requestSubmit()
  }
}
